import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-header" }
const _hoisted_2 = { class: "form-group row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Name", -1)
const _hoisted_4 = { class: "col-sm-4" }
const _hoisted_5 = { class: "form-group row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "DD Number", -1)
const _hoisted_7 = { class: "col-sm-4" }
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Email", -1)
const _hoisted_10 = { class: "col-sm-4" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Signature", -1)
const _hoisted_14 = ["height"]

import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { User} from '@/models';
import Editor from "ckeditor5/ckeditor";


export default /*#__PURE__*/_defineComponent({
  __name: 'Userdetails',
  setup(__props) {

const height = ref(window.innerHeight);

const store = useStore();
const user = computed((): User => store.getters['usermanagement/selected']);
const setUserDeep = (payload: {
  path: string;
  data: any;
}) => {
  store.commit("usermanagement/setUserDeep", payload);
  store.commit('usermanagement/addUnsavedChange', payload.path)
};

const messageheight = computed(() => {
  return height.value - height.value * 0.30;
});

const name = computed({
  get: () => user.value.name,
  set: (data) => {
    setUserDeep({ path: "name", data });
  },
});

const phone = computed({
  get: () => user.value.phone,
  set: (data) => {
    setUserDeep({ path: "phone", data });
  },
});

const email = computed({
  get: () => user.value.email,
  set: (data) => {
    setUserDeep({ path: "email", data });
  },
});

const signatureeditor = computed(() => {
  return Editor;
});

const signatureEditorConfig = computed(() => {
  return {
    toolbar: {
      items: ['heading', '|', 'bold', 'italic', 'link', '|', 'alignment:left', 'alignment:right', 'alignment:center',
        'alignment:justify', '|', 'bulletedList', 'numberedList', '|', 'insertTable', '|', 'outdent', 'indent',
        '|', 'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor', '|', 'undo', 'redo',],
    },
    licenseKey:
      "UUI3NHlwcFFOOXZpdFlqSFlhSUFYbWpCRHY4MnpuQWR1Mk95K2ZZWkxKSlVGclUrSFAvWEpmYndNRzNKLU1qQXlOREF4TURZPQ==",
    htmlSupport: {
      allow: [
        {
          name: /.*/,
          attributes: true,
          classes: true,
          styles: true,
        },
      ],
    },
  };
});

const signatureeditordata = computed({
  get: () => user.value.signature,
  set: (data) => {
    setUserDeep({ path: "signature", data });
  },
});


return (_ctx: any,_cache: any) => {
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
              type: "text",
              class: "form-control"
            }, null, 512), [
              [_vModelText, name.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((phone).value = $event)),
              type: "text",
              class: "form-control"
            }, null, 512), [
              [_vModelText, phone.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control",
              value: email.value,
              disabled: ""
            }, null, 8, _hoisted_11)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", {
            class: "col-sm-9 body-editor",
            height: messageheight.value
          }, [
            _createVNode(_component_ckeditor, {
              editor: signatureeditor.value,
              modelValue: signatureeditordata.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((signatureeditordata).value = $event)),
              config: signatureEditorConfig.value
            }, null, 8, ["editor", "modelValue", "config"])
          ], 8, _hoisted_14)
        ])
      ])
    ])
  ]))
}
}

})